// extracted by mini-css-extract-plugin
export default {"logo":"GameCardsLineProvider__logo--slots-FBh0E"};